import Vue from 'vue';
import Router from 'vue-router';
import store from '../store';

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Authentication
const Login = () => import('@/views/pages/Login')

// External orders mgmt
const OrdersFDExternal = () => import('@/views/pages/ordersFDExternal')

// Profile
const Profile = () => import('@/views/profile/View')

// Views
const Dashboard = () => import('@/views/Dashboard')
const Chats = () => import('@/views/chats/Chats')
const Chat = () => import('@/views/chats/Chat')

// Views
const ExportPage = () => import('@/views/export/ExportPage')

const PushStatusPage = () => import('@/views/pushes/PushStatusPage')
const ContentHealth = () => import('@/views/content-health/ContentHealth')
const ContentHealthDetail = () => import('@/views/content-health/ContentHealthDetail')

// Orders
const Orders = () => import('@/views/orders/Orders')
const OrdersCompleted = () => import('@/views/orders/OrdersCompleted')
const OrdersRD = () => import('@/views/orders/OrdersRD')
const OrdersED = () => import('@/views/orders/OrdersED')
const OrdersFD = () => import('@/views/orders/OrdersFD')
const OrdersLD = () => import('@/views/orders/OrdersLD')
const OrdersGD = () => import('@/views/orders/OrdersGD')
const OrdersPD = () => import('@/views/orders/OrdersPD')
const OrdersAH = () => import('@/views/orders/OrdersAH')
const Order = () => import('@/views/orders/Order')

// Entities
const Entities = () => import('@/views/entities/Entities')
const Entity = () => import('@/views/entities/Entity')
const EntityCreate = () => import('@/views/entities/EntityCreate')
const EntityEdit = () => import('@/views/entities/EntityEdit')
const EntityCategories = () => import('@/views/entities/EntityCategories')
const EntityProducts = () => import('@/views/entities/EntityProducts')
const EntityOptions = () => import('@/views/entities/EntityOptions')
const EntityVariants = () => import('@/views/entities/EntityVariants')
const EntityImport = () => import('@/views/entities/EntityImport')
const EntityPromotions = () => import('@/views/entities/EntityPromotions')
const EntityAdditional = () => import('@/views/entities/EntityAdditional')
const EntityDictionary = () => import('@/views/entities/EntityDictionary')
const EntitySettings = () => import('@/views/entities/EntitySettings')
const EntityDelivery = () => import('@/views/entities/Delivery')
const EntityWaitingPrice = () => import('@/views/entities/WaitingPrice')
const EntityTowerSettings = () => import('@/views/entities/TowerSettings')
const EntityDeliveryAddressRedirect = () => import('@/views/entities/DeliveryAddressRedirect')
const EntityDescription = () => import('@/views/entities/DescriptionEntityType')
const EntityAdditionalDescription = () => import('@/views/entities/AdditionalDescription')
const EntityAdditionalDescriptionEdit = () => import('@/views/entities/AdditionalDescriptionEdit')

// Entity product
const EntityProduct = () => import('@/views/entity-products/EntityProduct')
const EntityProductEdit = () => import('@/views/entity-products/Edit')
const EntityProductCreate = () => import('@/views/entity-products/Create')
const EntityProductCategories = () => import('@/views/entity-products/Categories')
const EntityProductOptions = () => import('@/views/entity-products/Options')
const EntityProductVariants = () => import('@/views/entity-products/Variants')

// Restaurants
const Restaurants = () => import('@/views/restaurants/Restaurants')
const CompaniesArchive = () => import('@/components/CompaniesArchive')
const Restaurant = () => import('@/views/restaurants/Restaurant')
const RestaurantCreate = () => import('@/views/restaurants/Create')
const RestaurantEdit = () => import('@/views/restaurants/Edit')
const RestaurantCategories = () => import('@/views/restaurants/Categories')
const RestaurantDishes = () => import('@/views/restaurants/Dishes')
const RestaurantIngredients = () => import('@/views/restaurants/Ingredients')
const RestaurantModifiers = () => import('@/views/restaurants/Modifiers')
const RestaurantImport = () => import('@/views/restaurants/Import')
const RestaurantPromotions = () => import('@/views/restaurants/Promotions')
const RestaurantDictionary = () => import('@/views/restaurants/RestaurantDictionary')
const RestaurantDelivery = () => import('@/views/restaurants/Delivery')
const RestaurantWaitingPrice = () => import('@/views/restaurants/WaitingPrice')
const RestaurantTowerSettings = () => import('@/views/restaurants/TowerSettings')
const RestaurantDeliveryAddressRedirect = () => import('@/views/restaurants/DeliveryAddressRedirect')
const RestaurantAPlace = () => import('@/views/restaurants/APlaceEntityType')
const RestaurantDescription = () => import('@/views/restaurants/DescriptionEntityType')
const RestaurantAdditionalDescription = () => import('@/views/restaurants/AdditionalDescription')
const RestaurantAdditionalDescriptionEdit = () => import('@/views/restaurants/AdditionalDescriptionEdit')
const RestaurantSettings = () => import('@/views/restaurants/RestaurantSettings')
const RestaurantShopCatalog = () => import('@/views/restaurants/ShopCatalog')

// Grocers
const Grocers = () => import('@/views/grocers/Grocers')
const Grocer = () => import('@/views/grocers/Grocer')
const GrocerCreate = () => import('@/views/grocers/Create')
const GrocerEdit = () => import('@/views/grocers/Edit')
const GrocerCategories = () => import('@/views/grocers/Categories')
const GrocerGoods = () => import('@/views/grocers/Goods')
const Grocerimport = () => import('@/views/grocers/Import')
const GrocerPromotions = () => import('@/views/grocers/Promotions')
const GrocerSettings = () => import('@/views/grocers/GrocerSettings')
const GrocerDelivery = () => import('@/views/grocers/Delivery')
const GrocerWaitingPrice = () => import('@/views/grocers/WaitingPrice')
const GrocerTowerSettings = () => import('@/views/grocers/TowerSettings')
const GrocerDeliveryAddressRedirect = () => import('@/views/grocers/DeliveryAddressRedirect')
const GrocerDictionary = () => import('@/views/grocers/GrocerDictionary')
const GrocerDescription = () => import('@/views/grocers/DescriptionEntityType')
const GrocerAdditionalDescription = () => import('@/views/grocers/AdditionalDescription')
const GrocerAdditionalDescriptionEdit = () => import('@/views/grocers/AdditionalDescriptionEdit')

// Goods
const GoodsCreate = () => import('@/views/grocers/GoodsCreate')
const GoodsInfo = () => import('@/views/grocers/GoodsInfo')
const GoodsEdit = () => import('@/views/grocers/GoodsUpdate')
const GoodsCategories = () => import('@/views/grocers/GoodsCategories')

// Pharmacies
const Pharmacies = () => import('@/views/pharmacies/Pharmacies')
const Pharmacy = () => import('@/views/pharmacies/Pharmacy')
const PharmacyCreate = () => import('@/views/pharmacies/Create')
const PharmacyEdit = () => import('@/views/pharmacies/Edit')
const PharmacyCategories = () => import('@/views/pharmacies/Categories')
const PharmacyGoods = () => import('@/views/pharmacies/Drugs')
const PharmacyPromotions = () => import('@/views/pharmacies/Promotions')
const PharmacyImport = () => import('@/views/pharmacies/Import')
const PharmacyDelivery = () => import('@/views/pharmacies/Delivery')
const PharmacyWaitingPrice = () => import('@/views/pharmacies/WaitingPrice')
const PharmacyDeliveryAddressRedirect = () => import('@/views/pharmacies/DeliveryAddressRedirect')
const PharmacyDescription = () => import('@/views/pharmacies/DescriptionEntityType')

// Drugs
const DrugCreate = () => import('@/views/pharmacies/DrugCreate')
const DrugInfo = () => import('@/views/pharmacies/DrugInfo')
const DrugEdit = () => import('@/views/pharmacies/DrugUpdate')
const DrugCategories = () => import('@/views/pharmacies/DrugCategories')

// Dishes
const Dish = () => import('@/views/dishes/Dish')
const DishEdit = () => import('@/views/dishes/Edit')
const DishCreate = () => import('@/views/dishes/Create')
const DishIngredients = () => import('@/views/dishes/Ingredients')
const DishModifiers = () => import('@/views/dishes/Modifiers')
const DishModifierGroups = () => import('@/views/dishes/ModifierGroups')
const DishModifierGroupCreate = () => import('@/views/dishes/ModifierGroupCreate')
const DishModifierGroupEdit = () => import('@/views/dishes/ModifierGroupEdit')
const DishIngredientGroups = () => import('@/views/dishes/IngredientGroups')
const DishIngredientGroupCreate = () => import('@/views/dishes/IngredientGroupCreate')
const DishIngredientGroupEdit = () => import('@/views/dishes/IngredientGroupEdit')

// Assistant
const AssistantList = () => import('@/views/assistant/AssistantList')
const AssistantCreate = () => import('@/views/assistant/AssistantCreate')
const Assistant = () => import('@/views/assistant/Assistant')
const AssistantEdit = () => import('@/views/assistant/AssistantEdit')
const AssistantCategories = () => import('@/views/assistant/AssistantCategories')
const AssistantOptions = () => import('@/views/assistant/AssistantOptions')
const AssistantPromotions = () => import('@/views/assistant/AssistantPromotions')
const AssistantExtras = () => import('@/views/assistant/AssistantExtras')
const AssistantServiceList = () => import('@/views/assistant/AssistantServiceList')
const AssistantServiceCreate = () => import('@/views/assistant/AssistantServiceCreate')
const AssistantService = () => import('@/views/assistant/AssistantService')
const AssistantServiceEdit = () => import('@/views/assistant/AssistantServiceEdit')
const AssistantServiceCategories = () => import('@/views/assistant/AssistantServiceCategories')
const AssistantServiceOptions = () => import('@/views/assistant/AssistantServiceOptions')
const AssistantServiceExtras = () => import('@/views/assistant/AssistantServiceExtras')
const AssistantDescription = () => import('@/views/assistant/DescriptionEntityType')

// Promotions
const PromotionCreate = () => import('@/views/promotions/Create')
const Promotion = () => import('@/views/promotions/Promotion')
const PromotionEdit = () => import('@/views/promotions/Edit')
const PromotionClients = () => import('@/views/promotions/Clients')
const PromotionImport = () => import('@/views/promotions/Import')
// Common promotions
const CommonPromotions = () => import('@/views/promotions/common/Promotions');
const CommonPromotion = () => import('@/views/promotions/common/Promotion')
const CommonPromotionClients = () => import('@/views/promotions/common/Clients')
const CommonPromotionImport = () => import('@/views/promotions/common/Import')
const CreateCommonPromotion = () => import('@/views/promotions/common/Create');
const EditCommonPromotion = () => import('@/views/promotions/common/Edit');

// Discount
const DiscountCardCreate = () => import('@/views/discount-cards/Create')
const DiscountCardView = () => import('@/views/discount-cards/View')
const DiscountCardEdit = () => import('@/views/discount-cards/Edit')
const DiscountCardClients = () => import('@/views/discount-cards/Clients')
const DiscountCardImport = () => import('@/views/discount-cards/Import')

// Customers
const Customers = () => import('@/views/customers/Customers');
const BusinessCompanies = () => import('@/views/business-companies/List');
const BusinessCompany = () => import('@/views/business-companies/Company');
const BusinessCompanyCreate = () => import('@/views/business-companies/Create');
const Customer = () => import('@/views/customers/Customer');
const CustomerCreate = () => import('@/views/customers/Create');
const CustomerEdit = () => import('@/views/customers/Edit');
const CustomerOrders = () => import('@/views/customers/Orders');
const CustomerPromocodes = () => import('@/views/customers/Promocodes');
const CustomerPromocodeCreate = () => import('@/views/customers/CustomerPromocodeCreate');

// DeliveryZones
const DeliveryZones = () => import('@/views/delivery-zones/List');
const DeliveryZonesParams = () => import('@/views/delivery-zones/Params');

// Partners
const Partners = () => import('@/views/partners/Partners');
const PartnersArchive = () => import('@/views/partners/PartnersArchive');
const Partner = () => import('@/views/partners/Partner');
const PartnerReports = () => import('@/views/partners/Reports');
const PartnerCreate = () => import('@/views/partners/Create');
const PartnerEdit = () => import('@/views/partners/Edit');
const PartnerOrders = () => import('@/views/partners/Orders');
const PartnerDiscountCards = () => import('@/views/partners/DiscountCards')
const PartnerRestaurants = () => import('@/views/partners/Restaurants');
const PartnerGrocers = () => import('@/views/partners/Grocers');
const PartnerPharmacy = () => import('@/views/partners/Pharmacy');
const PartnerAssistant = () => import('@/views/partners/Assistant');
const PartnerEntities = () => import('@/views/partners/Entities');

// Partners
const VipPartners = () => import('@/views/vip-partners/Partners');
const VipPartner = () => import('@/views/vip-partners/Partner');
const VipPartnerReports = () => import('@/views/vip-partners/Reports');
const VipPartnerCreate = () => import('@/views/vip-partners/Create');
const VipPartnerEdit = () => import('@/views/vip-partners/Edit');
const VipPartnerOrders = () => import('@/views/vip-partners/Orders');
const VipPartnerOrder = () => import('@/views/vip-partners/Order');
const VipPartnerOrdersAll = () => import('@/views/vip-partners/OrdersAll');
const VipPartnerOrdersUnallocated = () => import('@/views/vip-partners/OrdersUnallocated');

// Couriers
const Couriers = () => import('@/views/couriers/Couriers');
const Courier = () => import('@/views/couriers/Courier');
const CourierCreate = () => import('@/views/couriers/Create');
const CourierEdit = () => import('@/views/couriers/Edit');
const CourierOrders = () => import('@/views/couriers/Orders');

// Concierges
const Concierges = () => import('@/views/concierges/Concierges');
const Concierge = () => import('@/views/concierges/Concierge');
const ConciergeCreate = () => import('@/views/concierges/Create');
const ConciergeEdit = () => import('@/views/concierges/Edit');
const ConciergeOrders = () => import('@/views/concierges/Orders');

// Promocodes
const Promocodes = () => import('@/views/promocodes/Promocodes');
const Promocode = () => import('@/views/promocodes/Promocode');
const PromocodeCreate = () => import('@/views/promocodes/Create');
const PromocodeEdit = () => import('@/views/promocodes/Edit');
const PromocodeOrders = () => import('@/views/promocodes/Orders');
const PromocodeMassGeneration = () => import('@/views/promocodes/MassGeneration');
const HistoryDetail = () => import('@/views/promocodes/HistoryDetail');
const PromocodePersonalGeneration = () => import('@/views/promocodes/PersonalGeneration');
const PromocodeHistory = () => import('@/views/promocodes/History');

// Banners
const Banners = () => import('@/views/banners/Banners');
const Banner = () => import('@/views/banners/Banner');
const BannerCreate = () => import('@/views/banners/Create');
const BannerEdit = () => import('@/views/banners/Edit');

// Demands
const Demands = () => import('@/views/demands/Demands');
const Demand = () => import('@/views/demands/Demand');
const DemandCreate = () => import('@/views/demands/Create');
const DemandEdit = () => import('@/views/demands/Edit');

// AdsPlaces
const AdsPlaces = () => import('@/views/ads-places/AdsPlaces');
const AdsPlace = () => import('@/views/ads-places/AdsPlace');
const AdsPlaceCreate = () => import('@/views/ads-places/Create');
const AdsPlaceEdit = () => import('@/views/ads-places/Edit');

// OtherDelivery

const OtherDeliveries = () => import('@/views/other-delivery/OtherDeliveries');
const OtherDelivery = () => import('@/views/other-delivery/OtherDelivery');
const OtherDeliveryCreate = () => import('@/views/other-delivery/Create');
const OtherDeliveryEdit = () => import('@/views/other-delivery/Edit');

//AdsCampaigns
const AdsCampaigns = () => import('@/views/ads-campaigns/AdsCampaigns');
const AdsCampaign = () => import('@/views/ads-campaigns/AdsCampaign');
const AdsCampaignCreate = () => import('@/views/ads-campaigns/Create');
const AdsCampaignEdit = () => import('@/views/ads-campaigns/Edit');

// Stories
const Stories = () => import('@/views/stories/Stories');
const Story = () => import('@/views/stories/Story');
const StoryCreate = () => import('@/views/stories/Create');
const StoryEdit = () => import('@/views/stories/Edit');
const StorySettings = () => import('@/views/stories/Settings');

// Onboarding
const Onboarding = () => import('@/views/onboarding/Onboarding');
const OnboardingCreate = () => import('@/views/onboarding/Create');
const OnboardingEdit = () => import('@/views/onboarding/Edit');
const OnboardingStories = () => import('@/views/onboarding/OnboardingStories')

// Administrators
const Administrators = () => import('@/views/administrators/Administrators');
const Administrator = () => import('@/views/administrators/Administrator')
const AdministratorSettings = () => import('@/views/administrators/AdministratorSettings')

// Categories
const Categories = () => import('@/views/categories/Categories');
const Category = () => import('@/views/categories/Category')

//Addresses
const Addresses = () => import('@/views/addresses/Addresses');

// Verification codes
const VerificationCodes = () => import('@/views/verification-codes/VerificationCodes');

// Services
const SMSServiceTest = () => import('@/views/services/sms/SMSServiceTest');
const SMSServiceLogs = () => import('@/views/services/sms/SMSServiceLogs');
const ChangeLogs = () => import('@/views/services/change-logs/ChangeLogs');
const Telegram = () => import('@/views/services/telegram/Telegram');
const ServiceBots = () => import('@/views/services/telegram/ServiceBots');
const TelegramTest = () => import('@/views/services/telegram/TelegramTest');
const TelegramSettings = () => import('@/views/services/telegram/TelegramSettings');
const Max = () => import('@/views/services/max/Max');
const MaxSettings = () => import('@/views/services/max/MaxSettings');

// Settings
const MainPageSettings = () => import('@/views/settings/MainPageSettings')
const DesktopMenuSettings = () => import('@/views/settings/DesktopMenuSettings')
const PaymentPageSettings = () => import('@/views/settings/PaymentPageSettings')
const RepeatOrderSheetSettings = () => import('@/views/settings/RepeatOrderSheetSettings')
const IikoCardsSettings = () => import('@/views/settings/IikoCardsSettings')
const ShopCatalogSettings = () => import('@/views/settings/ShopCatalogSettings')
const ShopHolidaysSettings = () => import('@/views/settings/ShopHolidaysSettings')
const ShopFeedback = () => import('@/views/settings/ShopFeedback')
const IikoCardQrScheduleSettings = () => import('@/views/settings/IikoCardQrScheduleSettings')
const AgreementSettings = () => import('@/views/settings/AgreementSettings')
const PersonalInformationSettings = () => import('@/views/settings/PersonalInformationSettings')
const VerificationSettings = () => import('@/views/settings/VerificationSettings')
const ServiceFeeSettings = () => import('@/views/settings/ServiceFeeSettings')
const OrderUpsellSettings = () => import('@/views/settings/order-upsell-settings.vue');
const FeedbackSettings = () => import('@/views/settings/FeedbackSettings')
const VersionSettings = () => import('@/views/settings/VersionSettings')
const FaqSettings = () => import('@/views/settings/FaqSettings')
const ChatQuickReplies = () => import('@/views/settings/ChatQuickReplies')
const DeliverySettings = () => import('@/views/settings/DeliverySettings')
const EntitiesTypeSettings = () => import('@/views/settings/EntitiesTypeSettings')
const ReferalProgramSerttings = () => import('@/views/settings/ReferalProgramSettings')
const DiscountOnOrdersSerttings = () => import('@/views/settings/DiscountOnOrdersSerttings')
const CardScanGamificationSettings = () => import('@/views/settings/CardScanGamificationSettings')

// Common entity settings
const EntityTypeSettings = () => import('@/views/settings/entities/EntityTypeSettings')
const EntityType = () => import('@/views/settings/entities/EntityType')
const EntityTypeCreate = () => import('@/views/settings/entities/EntityTypeCreate')
const EntityTypeEdit = () => import('@/views/settings/entities/EntityTypeEdit')
const EntityPartnerBot = () => import('@/views/settings/entities/Telegram')
const EntityStatuses = () => import('@/views/settings/entities/Statuses')
const EntityPushes = () => import('@/views/settings/entities/Pushes')
const EntitiesDelivery = () => import('@/views/settings/entities/Delivery')
const EntitiesWaitingPrice = () => import('@/views/settings/entities/WaitingPrice')
const EntitiesImages = () => import('@/views/settings/entities/Images')
const EntitiesStatusDialogStatuses = () => import('@/views/settings/entities/StatusDialogStatuses')
const EntitiesStatusDialogStatus = () => import('@/views/settings/entities/StatusDialogStatus')
const EntitiesStatusDialogSettings = () => import ('@/views/settings/entities/StatusDialogSettings') 
const EntitiesDeliverySettings = () => import('@/views/settings/entities/DeliverySettings')

// Settings for static services
const StatusDialogStatuses = () => import('@/views/settings/StatusDialogStatuses')
const StatusDialogStatus = () => import('@/views/settings/StatusDialogStatus')
const StatusDialogSettings = () => import ('@/views/settings/StatusDialogSettings')

// Grocers settings
const GrocersSettings = () => import('@/views/settings/static-services/grocers/GrocersSettings')
const GrocersPartnerBot = () => import('@/views/settings/static-services/grocers/Telegram')
const GrocersDelivery = () => import('@/views/settings/static-services/grocers/Delivery')
const GrocersWaitingPrice = () => import('@/views/settings/static-services/grocers/WaitingPrice')
const GrocersImages = () => import('@/views/settings/static-services/grocers/Images')
const GrocersDeliverySettings = () => import('@/views/settings/static-services/grocers/DeliverySettings')
const GrocersStatuses = () => import('@/views/settings/static-services/grocers/Statuses')
const GrocersPushes = () => import('@/views/settings/static-services/grocers/Pushes')



// Restaurants settings
const RestaurantsSettings = () => import('@/views/settings/static-services/restaurants/RestaurantsSettings')
const RestaurantTypes = () => import('@/views/settings/static-services/restaurants/RestaurantTypes')
const RestaurantsStatuses = () => import('@/views/settings/static-services/restaurants/Statuses')
const RestaurantsPushes = () => import('@/views/settings/static-services/restaurants/Pushes')
const RestaurantsImages = () => import('@/views/settings/static-services/restaurants/Images')
const RestaurantsDishImages = () => import('@/views/settings/static-services/restaurants/DishImages')
const RestaurantsPartnerBot = () => import('@/views/settings/static-services/restaurants/Telegram')
const RestaurantsDelivery = () => import('@/views/settings/static-services/restaurants/Delivery')
const RestaurantsWaitingPrice = () => import('@/views/settings/static-services/restaurants/WaitingPrice')
const RestaurantsDeliverySettings = () => import('@/views/settings/static-services/restaurants/DeliverySettings')

// Pharmacy settings
const PharmacySettings = () => import('@/views/settings/static-services/pharmacies/PharmacySettings')
const PharmaciesPartnerBot = () => import('@/views/settings/static-services/pharmacies/Telegram')
const PharmaciesDelivery = () => import('@/views/settings/static-services/pharmacies/Delivery')
const PharmaciesWaitingPrice = () => import('@/views/settings/static-services/pharmacies/WaitingPrice')

const CustomerLogs = () => import('@/views/analitics/CustomerLogs');
const FormResults = () => import('@/views/forms/Results');

const Towers = () => import('@/views/tower-time/Towers');
const TowerTime = () => import('@/views/tower-time/TowerTime');

const CourierService = () => import('@/views/services/courier/CourierService');
const StartTowers = () => import('@/views/services/courier/StartTowers');
const CourierList = () => import('@/views/services/courier/CourierList');
const IikoHooks = () => import('@/views/services/courier/IikoHooks');
const YumaHooks = () => import('@/views/services/courier/YumaHooks');

// Surveys
const Surveys = () => import('@/views/surveys/List');
const Survey = () => import('@/views/surveys/Detail');
const SurveyCreate = () => import('@/views/surveys/Create');
const SurveyEdit = () => import('@/views/surveys/Edit');
const SurveyResults = () => import('@/views/surveys/results/List');
const SurveyResult = () => import('@/views/surveys/results/Detail');
const SurveyQuestions = () => import('@/views/surveys/questions/List');
const SurveyQuestion = () => import('@/views/surveys/questions/Detail');
const SurveyQuestionCreate = () => import('@/views/surveys/questions/Create');
const SurveyQuestionEdit = () => import('@/views/surveys/questions/Edit');

// Segments
const Segments = () => import('@/views/segments/Segments');
const Segment = () => import('@/views/segments/Segment');
const SegmentEdit = () => import('@/views/segments/SegmentEdit');

// Trigger Campaigns
const TriggerCampaigns = () => import('@/views/trigger-campaigns/TriggerCampaigns');
const TriggerCampaign = () => import('@/views/trigger-campaigns/TriggerCampaign');
const TriggerCampaignCreate = () => import('@/views/trigger-campaigns/TriggerCampaignCreate');
const TriggerCampaignEdit = () => import('@/views/trigger-campaigns/TriggerCampaignEdit');

// AB Tests
const AbTests = () => import('@/views/ab-tests/List');
const AbTest = () => import('@/views/ab-tests/Detail');
const AbTestCreate = () => import('@/views/ab-tests/Create');
const AbTestEdit = () => import('@/views/ab-tests/Edit');
const AbTestStatistics = () => import('@/views/ab-tests/Statistics');

// iiko Orders
const IikoOrders = () => import('@/views/iiko-orders/List');
const IikoOrder = () => import('@/views/iiko-orders/Detail');

Vue.use(Router)

const router = new Router({
    mode: 'history', // https://router.vuejs.org/api/#mode
    linkActiveClass: 'active',
    scrollBehavior: () => ({ y: 0 }),
    routes: configRoutes()
});

router.beforeEach((to, from, next) => {
    if (to.path === '/pages/login' || to.path === '/pages/orders-fd-external') {
        if (!store.getters.isAuthenticated) {
            next();
            return;
        }
        next('/');
    } else {
        if (store.getters.isAuthenticated) {
            next();
            return;
        }
        next('/pages/login');
    }
});

export default router;

// Бизнес-админ партнёра не имеет доступа к чатам оператор↔клиент
// (пункт меню скрыт через _adminOnly(), бэкенд отдаёт 403 — тут закрываем deep-link).
function businessAdminChatsGuard(to, from, next) {
    let isBusinessAdmin = false;
    try {
        isBusinessAdmin = !!JSON.parse(localStorage.getItem('settings'))?.is_business_admin;
    } catch (e) {
        isBusinessAdmin = false;
    }
    if (isBusinessAdmin) {
        next('/');
    } else {
        next();
    }
}

function configRoutes() {
    return [
        {
            path: '/',
            redirect: '/dashboard',
            component: TheContainer,
            children: [
                {
                    path: 'dashboard',
                    meta: { label: 'Панель управления' },
                    name: 'Dashboard',
                    component: Dashboard
                },
                {
                    path: 'chats',
                    meta: { label: 'Чаты' },
                    beforeEnter: businessAdminChatsGuard,
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: '',
                            name: 'Chats',
                            component: Chats
                        },
                        {
                            path: ':chatId',
                            meta: { label: 'Чат' },
                            name: 'Chat',
                            component: Chat
                        }
                    ]
                },
                {
                    path: 'orders',
                    meta: { label: 'Все заказы' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: '',
                            name: 'Orders',
                            meta: { label: 'Все заказы' },
                            component: Orders
                        },
                        {
                            path: 'completed',
                            name: 'OrdersCompleted',
                            meta: { label: 'Завершенные' },
                            component: OrdersCompleted
                        },
                        {
                            path: 'orders-rd',
                            name: 'OrdersRD',
                            meta: { label: 'Доставка ресторанов' },
                            component: OrdersRD
                        },
                        {
                            path: 'orders-ed/:entityTypeId',
                            name: 'OrdersED',
                            component: OrdersED
                        },
                        {
                            path: 'orders-fd',
                            name: 'OrdersFD',
                            meta: { label: 'Доставка цветов' },
                            component: OrdersFD
                        },
                        {
                            path: 'orders-ld',
                            name: 'OrdersLD',
                            meta: { label: 'Химчистки' },
                            component: OrdersLD
                        },
                        {
                            path: 'orders-gd',
                            name: 'OrdersGD',
                            meta: { label: 'Продукты' },
                            component: OrdersGD
                        },
                        {
                            path: 'orders-pd',
                            name: 'OrdersPD',
                            meta: { label: 'Аптеки' },
                            component: OrdersPD
                        },
                        {
                            path: 'orders-ah',
                            name: 'OrdersAH',
                            meta: { label: 'Помощники' },
                            component: OrdersAH
                        },
                        {
                            path: ':id',
                            name: 'Order',
                            component: Order
                        }

                    ]
                },
                {
                    path: 'restaurants',
                    meta: { label: 'Рестораны' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: '',
                            meta: { label: 'Рестораны' },
                            name: 'Restaurants',
                            component: Restaurants
                        },
                        {
                            path: 'create',
                            meta: { label: 'Создание ресторана' },
                            name: 'RestaurantCreate',
                            component: RestaurantCreate
                        },
                        {
                            path: 'archive',
                            meta: { label: 'Архив' },
                            name: 'RestaurantsArchive',
                            component: CompaniesArchive,
                            props: {
                                title: 'Архив ресторанов',
                                backLink: '/restaurants',
                                apiPath: '/restaurants',
                                service: 'restaurants',
                            },
                        },
                        {
                            path: ':id',
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: '',
                                    name: 'Restaurant',
                                    component: Restaurant
                                },
                                {
                                    path: 'edit',
                                    meta: { label: 'Редактирование' },
                                    name: 'RestaurantEdit',
                                    component: RestaurantEdit
                                },
                                {
                                    path: 'categories',
                                    meta: { label: 'Категории' },
                                    name: 'RestaurantCategories',
                                    component: RestaurantCategories
                                },
                                {
                                    path: 'ingredients',
                                    meta: { label: 'Ингредиенты' },
                                    name: 'RestaurantIngredients',
                                    component: RestaurantIngredients
                                },
                                {
                                    path: 'modifiers',
                                    meta: { label: 'Модификаторы' },
                                    name: 'RestaurantModifiers',
                                    component: RestaurantModifiers
                                },
                                {
                                    path: 'import',
                                    meta: { label: 'Импорт' },
                                    name: 'RestaurantImport',
                                    component: RestaurantImport
                                },
                                {
                                    path: 'dishes',
                                    meta: { label: 'Меню' },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: '',
                                            name: 'RestaurantDishes',
                                            component: RestaurantDishes,
                                        },
                                        {
                                            path: 'create',
                                            meta: { label: 'Создание блюда' },
                                            name: 'DishCreate',
                                            component: DishCreate,
                                        },
                                        {
                                            path: ':dish_id',
                                            component: {
                                                render(c) { return c('router-view') }
                                            },
                                            children: [
                                                {
                                                    path: '',
                                                    name: 'Dish',
                                                    component: Dish
                                                },
                                                {
                                                    path: 'edit',
                                                    meta: { label: 'Редактирование' },
                                                    name: 'DishEdit',
                                                    component: DishEdit
                                                },
                                                {
                                                    path: 'ingredients',
                                                    meta: { label: 'Ингредиенты' },
                                                    name: 'DishIngredients',
                                                    component: DishIngredients
                                                },
                                                {
                                                    path: 'modifiers',
                                                    meta: { label: 'Модификаторы' },
                                                    name: 'DishModifiers',
                                                    component: DishModifiers
                                                },
                                                {
                                                    path: 'modifier-groups',
                                                    meta: { label: 'Группы модификаторов' },
                                                    component: {
                                                        render(c) { return c('router-view') }
                                                    },
                                                    children: [
                                                        {
                                                            path: '',
                                                            name: 'DishModifierGroups',
                                                            component: DishModifierGroups,
                                                        },
                                                        {
                                                            path: 'create',
                                                            meta: { label: 'Создание группы модификаторов' },
                                                            name: 'DishModifierGroupCreate',
                                                            component: DishModifierGroupCreate,
                                                        },
                                                        {
                                                            path: ':group_id',
                                                            component: {
                                                                render(c) { return c('router-view') }
                                                            },
                                                            children: [
                                                                {
                                                                    path: '',
                                                                    name: 'DishModifierGroupEdit',
                                                                    component: DishModifierGroupEdit
                                                                },
                                                            ]
                                                        },
                                                    ]
                                                },
                                                {
                                                    path: 'ingredient-groups',
                                                    meta: { label: 'Группы ингредиентов' },
                                                    component: {
                                                        render(c) { return c('router-view') }
                                                    },
                                                    children: [
                                                        {
                                                            path: '',
                                                            name: 'DishIngredientGroups',
                                                            component: DishIngredientGroups,
                                                        },
                                                        {
                                                            path: 'create',
                                                            meta: { label: 'Создание группы ингредиентов' },
                                                            name: 'DishIngredientGroupCreate',
                                                            component: DishIngredientGroupCreate,
                                                        },
                                                        {
                                                            path: ':group_id',
                                                            component: {
                                                                render(c) { return c('router-view') }
                                                            },
                                                            children: [
                                                                {
                                                                    path: '',
                                                                    name: 'DishIngredientGroupEdit',
                                                                    component: DishIngredientGroupEdit
                                                                },
                                                            ]
                                                        },
                                                    ]
                                                },
                                            ]
                                        },
                                    ]
                                },
                                {
                                    path: 'promotions',
                                    meta: { label: 'Акции' },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: '',
                                            name: 'RestaurantPromotions',
                                            component: RestaurantPromotions,
                                        },
                                        {
                                            path: 'create',
                                            meta: { label: 'Создание' },
                                            name: 'RestaurantPromotionCreate',
                                            component: PromotionCreate,
                                        },
                                        {
                                            path: ':promotion_id',
                                            component: {
                                                render(c) { return c('router-view') }
                                            },
                                            children: [
                                                {
                                                    path: '',
                                                    name: 'RestaurantPromotion',
                                                    component: Promotion
                                                },
                                                {
                                                    path: 'edit',
                                                    meta: { label: 'Редактирование' },
                                                    name: 'RestaurantPromotionEdit',
                                                    component: PromotionEdit
                                                },
                                                {
                                                    path: 'clients',
                                                    meta: { label: 'Клиенты' },
                                                    name: 'RestaurantPromotionClients',
                                                    component: PromotionClients
                                                },
                                                {
                                                    path: 'import',
                                                    meta: { label: 'Импорт' },
                                                    name: 'RestaurantPromotionImport',
                                                    component: PromotionImport
                                                },
                                            ]
                                        },
                                    ]
                                },
                                {
                                    path: 'dictionary',
                                    meta: { label: 'Словарь' },
                                    name: 'RestaurantDictionary',
                                    component: RestaurantDictionary
                                },
                                {
                                    path: 'delivery',
                                    meta: { label: 'Доставка' },
                                    name: 'RestaurantDelivery',
                                    component: RestaurantDelivery
                                },
                                {
                                    path: 'tower-settings',
                                    meta: { label: 'Настройки по башням' },
                                    name: 'RestaurantDelivery',
                                    component: RestaurantTowerSettings
                                },
                                {
                                    path: 'delivery-address-redirect',
                                    meta: { label: 'Перенаправление доставки' },
                                    name: 'RestaurantDeliveryAddressRedirect',
                                    component: RestaurantDeliveryAddressRedirect
                                },
                                {
                                    path: 'waiting-price',
                                    name: 'RestaurantWaitingPrice',
                                    meta: { label: 'Платное ожидание' },
                                    component: RestaurantWaitingPrice,
                                },
                                {
                                    path: 'aplace',
                                    meta: { label: 'Реклама' },
                                    name: 'RestaurantAPlace',
                                    component: RestaurantAPlace
                                },
                                {
                                    path: 'description',
                                    meta: { label: 'Описание' },
                                    name: 'RestaurantDescription',
                                    component: RestaurantDescription
                                },
                                {
                                    path: 'additional-description',
                                    meta: { label: 'Дополнительное описание' },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: '',
                                            name: 'RestaurantAdditionalDescription',
                                            component: RestaurantAdditionalDescription,
                                        },

                                        {
                                            path: ':category_id',
                                            meta: { label: 'Редактирование' },
                                            name: 'RestaurantAdditionalDescriptionEdit',
                                            component: RestaurantAdditionalDescriptionEdit,
                                        },
                                    ]
                                },
                                {
                                    path: 'settings',
                                    meta: { label: 'Настройки' },
                                    name: 'RestaurantSettings',
                                    component: RestaurantSettings
                                },
                                {
                                    path: 'shop-catalog',
                                    meta: { label: 'Стол заказов' },
                                    name: 'RestaurantShopCatalog',
                                    component: RestaurantShopCatalog
                                },
                            ]
                        },
                    ]
                },
                {
                    path: 'entities/:code',
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: '',
                            name: 'Entities',
                            component: Entities
                        },
                        {
                            path: 'create',
                            meta: { label: 'Создание сервиса' },
                            name: 'EntityCreate',
                            component: EntityCreate
                        },
                        {
                            path: 'archive',
                            meta: { label: 'Архив' },
                            name: 'EntitiesArchive',
                            component: CompaniesArchive,
                            props: route => ({
                                title: 'Архив сервисов',
                                backLink: `/entities/${route.params.code}`,
                                apiPath: `/entities/${route.params.code}`,
                                service: `entities/${route.params.code}`,
                            }),
                        },
                        {
                            path: ':id',
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: '',
                                    name: 'Entity',
                                    component: Entity
                                },
                                {
                                    path: 'edit',
                                    meta: { label: 'Редактирование' },
                                    name: 'EntityEdit',
                                    component: EntityEdit
                                },
                                {
                                    path: 'categories',
                                    meta: { label: 'Категории' },
                                    name: 'EntityCategories',
                                    component: EntityCategories
                                },
                                {
                                    path: 'options',
                                    meta: { label: 'Опции' },
                                    name: 'EntityOptions',
                                    component: EntityOptions
                                },
                                {
                                    path: 'variants',
                                    meta: { label: 'Варианты' },
                                    name: 'EntityVariants',
                                    component: EntityVariants
                                },
                                {
                                    path: 'import',
                                    meta: { label: 'Импорт' },
                                    name: 'EntityImport',
                                    component: EntityImport
                                },
                                {
                                    path: 'products',
                                    meta: { label: 'Продукция' },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: '',
                                            name: 'EntityProducts',
                                            component: EntityProducts,
                                        },
                                        {
                                            path: 'create',
                                            meta: { label: 'Создание блюда' },
                                            name: 'EntityProductCreate',
                                            component: EntityProductCreate,
                                        },
                                        {
                                            path: ':entity_product_id',
                                            component: {
                                                render(c) { return c('router-view') }
                                            },
                                            children: [
                                                {
                                                    path: '',
                                                    name: 'EntityProduct',
                                                    component: EntityProduct
                                                },
                                                {
                                                    path: 'edit',
                                                    meta: { label: 'Редактирование' },
                                                    name: 'EntityProductEdit',
                                                    component: EntityProductEdit
                                                },
                                                {
                                                    path: 'categories',
                                                    meta: { label: 'Категории' },
                                                    name: 'EntityProductCategories',
                                                    component: EntityProductCategories
                                                },
                                                {
                                                    path: 'options',
                                                    meta: { label: 'Опции' },
                                                    name: 'EntityProductOptions',
                                                    component: EntityProductOptions
                                                },
                                                {
                                                    path: 'variants',
                                                    meta: { label: 'Варианты' },
                                                    name: 'EntityProductVariants',
                                                    component: EntityProductVariants
                                                },
                                            ]
                                        },
                                    ]
                                },
                                {
                                    path: 'promotions',
                                    meta: { label: 'Акции' },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: '',
                                            name: 'EntityPromotions',
                                            component: EntityPromotions,
                                        },
                                        {
                                            path: 'create',
                                            meta: { label: 'Создание' },
                                            name: 'EntityPromotionCreate',
                                            component: PromotionCreate,
                                        },
                                        {
                                            path: ':promotion_id',
                                            component: {
                                                render(c) { return c('router-view') }
                                            },
                                            children: [
                                                {
                                                    path: '',
                                                    name: 'EntityPromotion',
                                                    component: Promotion
                                                },
                                                {
                                                    path: 'edit',
                                                    meta: { label: 'Редактирование' },
                                                    name: 'EntityPromotionEdit',
                                                    component: PromotionEdit
                                                },
                                                {
                                                    path: 'clients',
                                                    meta: { label: 'Клиенты' },
                                                    name: 'EntityPromotionClients',
                                                    component: PromotionClients
                                                },
                                                {
                                                    path: 'import',
                                                    meta: { label: 'Импорт' },
                                                    name: 'EntityPromotionImport',
                                                    component: PromotionImport
                                                },
                                            ]
                                        },
                                    ]
                                },
                                {
                                    path: 'settings',
                                    meta: { label: 'Настройки' },
                                    name: 'EntitySettings',
                                    component: EntitySettings
                                },
                                {
                                    path: 'dictionary',
                                    meta: { label: 'Словарь' },
                                    name: 'EntityDictionary',
                                    component: EntityDictionary
                                },
                                {
                                    path: 'additional',
                                    meta: { label: 'Дополнительно' },
                                    name: 'EntityAdditional',
                                    component: EntityAdditional
                                },
                                {
                                    path: 'delivery',
                                    meta: { label: 'Доставка' },
                                    name: 'EntityDelivery',
                                    component: EntityDelivery
                                },
                                {
                                    path: 'tower-settings',
                                    meta: { label: 'Настройки по башням' },
                                    name: 'EntityDelivery',
                                    component: EntityTowerSettings
                                },
                                {
                                    path: 'delivery-address-redirect',
                                    meta: { label: 'Перенаправление доставки' },
                                    name: 'EntityDeliveryAddressRedirect',
                                    component: EntityDeliveryAddressRedirect
                                },
                                {
                                    path: 'waiting-price',
                                    name: 'EntityWaitingPrice',
                                    meta: { label: 'Платное ожидание' },
                                    component: EntityWaitingPrice,
                                },
                                {
                                    path: 'description',
                                    meta: { label: 'Описание' },
                                    name: 'EntityDescription',
                                    component: EntityDescription
                                },
                                {
                                    path: 'additional-description',
                                    meta: { label: 'Дополнительное описание' },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: '',
                                            name: 'EntityAdditionalDescription',
                                            component: EntityAdditionalDescription,
                                        },

                                        {
                                            path: ':category_id',
                                            meta: { label: 'Редактирование' },
                                            name: 'EntityAdditionalDescriptionEdit',
                                            component: EntityAdditionalDescriptionEdit,
                                        },
                                    ]
                                },
                            ]
                        },
                    ]
                },
                {
                    path: 'grocers',
                    meta: { label: 'Магазины продуктов' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: '',
                            meta: { label: 'Магазины продуктов' },
                            name: 'Grocers',
                            component: Grocers
                        },
                        {
                            path: 'create',
                            meta: { label: 'Создание магазина продуктов' },
                            name: 'GrocerCreate',
                            component: GrocerCreate
                        },
                        {
                            path: 'archive',
                            meta: { label: 'Архив' },
                            name: 'GrocersArchive',
                            component: CompaniesArchive,
                            props: {
                                title: 'Архив магазинов',
                                backLink: '/grocers',
                                apiPath: '/grocers',
                                service: 'grocers',
                            },
                        },
                        {
                            path: ':id',
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: '',
                                    name: 'Grocer',
                                    component: Grocer
                                },
                                {
                                    path: 'edit',
                                    meta: { label: 'Редактирование' },
                                    name: 'GrocerEdit',
                                    component: GrocerEdit
                                },
                                {
                                    path: 'categories',
                                    meta: { label: 'Категории' },
                                    name: 'GrocerCategories',
                                    component: GrocerCategories
                                },
                                {
                                    path: 'import',
                                    meta: { label: 'Импорт' },
                                    name: 'GrocerImport',
                                    component: Grocerimport
                                },
                                {
                                    path: 'promotions',
                                    meta: { label: 'Акции' },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: '',
                                            name: 'GrocerPromotions',
                                            component: GrocerPromotions,
                                        },
                                        {
                                            path: 'create',
                                            meta: { label: 'Создание' },
                                            name: 'GrocerPromotionCreate',
                                            component: PromotionCreate,
                                        },
                                        {
                                            path: ':promotion_id',
                                            component: {
                                                render(c) { return c('router-view') }
                                            },
                                            children: [
                                                {
                                                    path: '',
                                                    name: 'GrocerPromotion',
                                                    component: Promotion
                                                },
                                                {
                                                    path: 'edit',
                                                    meta: { label: 'Редактирование' },
                                                    name: 'GrocerPromotionEdit',
                                                    component: PromotionEdit
                                                },
                                                {
                                                    path: 'clients',
                                                    meta: { label: 'Клиенты' },
                                                    name: 'GrocerPromotionClients',
                                                    component: PromotionClients
                                                },
                                                {
                                                    path: 'import',
                                                    meta: { label: 'Импорт' },
                                                    name: 'GrocerPromotionImport',
                                                    component: PromotionImport
                                                },
                                            ]
                                        },
                                    ]
                                },
                                {
                                    path: 'goods',
                                    meta: { label: 'Товары' },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: '',
                                            name: 'GrocerGoods',
                                            component: GrocerGoods,
                                        },
                                        {
                                            path: 'create',
                                            meta: { label: 'Создание товара' },
                                            name: 'GoodsCreate',
                                            component: GoodsCreate,
                                        },
                                        {
                                            path: ':goods_id',
                                            component: {
                                                render(c) { return c('router-view') }
                                            },
                                            children: [
                                                {
                                                    path: '',
                                                    name: 'GoodsInfo',
                                                    component: GoodsInfo
                                                },
                                                {
                                                    path: 'edit',
                                                    meta: { label: 'Редактирование' },
                                                    name: 'GoodsEdit',
                                                    component: GoodsEdit
                                                },
                                                {
                                                    path: 'categories',
                                                    meta: { label: 'Категории' },
                                                    name: 'GoodsCategories',
                                                    component: GoodsCategories
                                                },
                                            ]
                                        },
                                    ]
                                },
                                {
                                    path: 'settings',
                                    meta: { label: 'Настройки' },
                                    name: 'GrocerSettings',
                                    component: GrocerSettings
                                },
                                {
                                    path: 'delivery',
                                    meta: { label: 'Доставка' },
                                    name: 'GrocerDelivery',
                                    component: GrocerDelivery
                                },
                                {
                                    path: 'tower-settings',
                                    meta: { label: 'Настройки по башням' },
                                    name: 'GrocerDelivery',
                                    component: GrocerTowerSettings
                                },
                                {
                                    path: 'dictionary',
                                    meta: { label: 'Словарь' },
                                    name: 'GrocerDictionary',
                                    component: GrocerDictionary
                                },
                                {
                                    path: 'delivery-address-redirect',
                                    meta: { label: 'Перенаправление доставки' },
                                    name: 'GrocerDeliveryAddressRedirect',
                                    component: GrocerDeliveryAddressRedirect
                                },
                                {
                                    path: 'waiting-price',
                                    name: 'GrocerWaitingPrice',
                                    meta: { label: 'Платное ожидание' },
                                    component: GrocerWaitingPrice,
                                },
                                {
                                    path: 'description',
                                    meta: { label: 'Описание' },
                                    name: 'GrocerDescription',
                                    component: GrocerDescription
                                },
                                {
                                    path: 'additional-description',
                                    meta: { label: 'Дополнительное описание' },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: '',
                                            name: 'GrocerAdditionalDescription',
                                            component: GrocerAdditionalDescription,
                                        },

                                        {
                                            path: ':category_id',
                                            meta: { label: 'Редактирование' },
                                            name: 'GrocerAdditionalDescriptionEdit',
                                            component: GrocerAdditionalDescriptionEdit,
                                        },
                                    ]
                                },
                            ]
                        },
                    ]
                },
                {
                    path: 'assistants',
                    meta: { label: 'Помощники' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: '',
                            meta: { label: 'Помощники' },
                            name: 'AssistantList',
                            component: AssistantList
                        },
                        {
                            path: 'create',
                            meta: { label: 'Создание помощника' },
                            name: 'AssistantCreate',
                            component: AssistantCreate
                        },
                        {
                            path: 'archive',
                            meta: { label: 'Архив' },
                            name: 'AssistantsArchive',
                            component: CompaniesArchive,
                            props: {
                                title: 'Архив помощников',
                                backLink: '/assistants',
                                apiPath: '/assistants',
                                service: 'assistants',
                            },
                        },
                        {
                            path: ':id',
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: '',
                                    name: 'Assistant',
                                    component: Assistant
                                },
                                {
                                    path: 'edit',
                                    meta: { label: 'Редактирование' },
                                    name: 'AssistantEdit',
                                    component: AssistantEdit
                                },
                                {
                                    path: 'categories',
                                    meta: { label: 'Категории' },
                                    name: 'AssistantCategories',
                                    component: AssistantCategories
                                },
                                {
                                    path: 'options',
                                    meta: { label: 'Варианты' },
                                    name: 'AssistantOptions',
                                    component: AssistantOptions
                                },
                                {
                                    path: 'extras',
                                    meta: { label: 'Дополнительно' },
                                    name: 'AssistantExtras',
                                    component: AssistantExtras
                                },
                                {
                                    path: 'description',
                                    meta: { label: 'Описание' },
                                    name: 'AssistantDescription',
                                    component: AssistantDescription
                                },
                                {
                                    path: 'promotions',
                                    meta: { label: 'Акции' },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: '',
                                            name: 'AssistantPromotions',
                                            component: AssistantPromotions,
                                        },
                                        {
                                            path: 'create',
                                            meta: { label: 'Создание' },
                                            name: 'AssistantPromotionCreate',
                                            component: PromotionCreate,
                                        },
                                        {
                                            path: ':promotion_id',
                                            component: {
                                                render(c) { return c('router-view') }
                                            },
                                            children: [
                                                {
                                                    path: '',
                                                    name: 'AssistantPromotion',
                                                    component: Promotion
                                                },
                                                {
                                                    path: 'edit',
                                                    meta: { label: 'Редактирование' },
                                                    name: 'AssistantPromotionEdit',
                                                    component: PromotionEdit
                                                },
                                                {
                                                    path: 'clients',
                                                    meta: { label: 'Клиенты' },
                                                    name: 'AssistantPromotionClients',
                                                    component: PromotionClients
                                                },
                                                {
                                                    path: 'import',
                                                    meta: { label: 'Импорт' },
                                                    name: 'AssistantPromotionImport',
                                                    component: PromotionImport
                                                },
                                            ]
                                        },
                                    ]
                                },
                                {
                                    path: 'service',
                                    meta: { label: 'Услуги' },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: '',
                                            name: 'AssistantServiceList',
                                            component: AssistantServiceList,
                                        },
                                        {
                                            path: 'create',
                                            meta: { label: 'Создание услуги' },
                                            name: 'AssistantServiceCreate',
                                            component: AssistantServiceCreate,
                                        },
                                        {
                                            path: ':service_id',
                                            component: {
                                                render(c) { return c('router-view') }
                                            },
                                            children: [
                                                {
                                                    path: '',
                                                    name: 'AssistantService',
                                                    component: AssistantService
                                                },
                                                {
                                                    path: 'edit',
                                                    meta: { label: 'Редактирование' },
                                                    name: 'AssistantServiceEdit',
                                                    component: AssistantServiceEdit
                                                },
                                                {
                                                    path: 'categories',
                                                    meta: { label: 'Категории' },
                                                    name: 'AssistantServiceCategories',
                                                    component: AssistantServiceCategories
                                                },
                                                {
                                                    path: 'options',
                                                    meta: { label: 'Варианты' },
                                                    name: 'AssistantServiceOptions',
                                                    component: AssistantServiceOptions
                                                },
                                                {
                                                    path: 'extras',
                                                    meta: { label: 'Дополнительно' },
                                                    name: 'AssistantServiceExtras',
                                                    component: AssistantServiceExtras
                                                },
                                            ]
                                        },
                                    ]
                                },
                            ]
                        },
                    ]
                },


                /** TODO - remove*/
                {
                    path: 'pharmacies',
                    meta: { label: 'Аптеки' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: '',
                            meta: { label: 'Аптеки' },
                            name: 'Pharmacies',
                            component: Pharmacies
                        },
                        {
                            path: 'create',
                            meta: { label: 'Создание аптеки' },
                            name: 'PharmacyCreate',
                            component: PharmacyCreate
                        },
                        {
                            path: 'archive',
                            meta: { label: 'Архив' },
                            name: 'PharmaciesArchive',
                            component: CompaniesArchive,
                            props: {
                                title: 'Архив аптек',
                                backLink: '/pharmacies',
                                apiPath: '/pharmacies',
                                service: 'pharmacies',
                            },
                        },
                        {
                            path: ':id',
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: '',
                                    name: 'Pharmacy',
                                    component: Pharmacy
                                },
                                {
                                    path: 'edit',
                                    meta: { label: 'Редактирование' },
                                    name: 'PharmacyEdit',
                                    component: PharmacyEdit
                                },
                                {
                                    path: 'categories',
                                    meta: { label: 'Категории' },
                                    name: 'PharmacyCategories',
                                    component: PharmacyCategories
                                },
                                {
                                    path: 'promotions',
                                    meta: { label: 'Акции' },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: '',
                                            name: 'PharmacyPromotions',
                                            component: PharmacyPromotions,
                                        },
                                        {
                                            path: 'create',
                                            meta: { label: 'Создание' },
                                            name: 'PharmacyPromotionCreate',
                                            component: PromotionCreate,
                                        },
                                        {
                                            path: ':promotion_id',
                                            component: {
                                                render(c) { return c('router-view') }
                                            },
                                            children: [
                                                {
                                                    path: '',
                                                    name: 'PharmacyPromotion',
                                                    component: Promotion
                                                },
                                                {
                                                    path: 'edit',
                                                    meta: { label: 'Редактирование' },
                                                    name: 'PharmacyPromotionEdit',
                                                    component: PromotionEdit
                                                },
                                                {
                                                    path: 'clients',
                                                    meta: { label: 'Клиенты' },
                                                    name: 'PharmacyPromotionClients',
                                                    component: PromotionClients
                                                },
                                                {
                                                    path: 'import',
                                                    meta: { label: 'Импорт' },
                                                    name: 'PharmacyPromotionImport',
                                                    component: PromotionImport
                                                },
                                            ]
                                        },
                                    ]
                                },
                                {
                                    path: 'drugs',
                                    meta: { label: 'Лекарства' },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: '',
                                            name: 'PharmacyGoods',
                                            component: PharmacyGoods,
                                        },
                                        {
                                            path: 'create',
                                            meta: { label: 'Создание лекарства' },
                                            name: 'DrugCreate',
                                            component: DrugCreate,
                                        },
                                        {
                                            path: ':drug_id',
                                            component: {
                                                render(c) { return c('router-view') }
                                            },
                                            children: [
                                                {
                                                    path: '',
                                                    name: 'DrugInfo',
                                                    component: DrugInfo
                                                },
                                                {
                                                    path: 'edit',
                                                    meta: { label: 'Редактирование' },
                                                    name: 'DrugEdit',
                                                    component: DrugEdit
                                                },
                                                {
                                                    path: 'categories',
                                                    meta: { label: 'Категории' },
                                                    name: 'DrugCategories',
                                                    component: DrugCategories
                                                },
                                            ]
                                        },
                                    ]
                                },
                                {
                                    path: 'import',
                                    meta: { label: 'Импорт' },
                                    name: 'PharmacyImport',
                                    component: PharmacyImport
                                },
                                {
                                    path: 'delivery',
                                    meta: { label: 'Доставка' },
                                    name: 'PharmacyDelivery',
                                    component: PharmacyDelivery
                                },
                                {
                                    path: 'delivery-address-redirect',
                                    meta: { label: 'Перенаправление доставки' },
                                    name: 'PharmacyDeliveryAddressRedirect',
                                    component: PharmacyDeliveryAddressRedirect
                                },
                                {
                                    path: 'description',
                                    meta: { label: 'Описание' },
                                    name: 'PharmacyDescription',
                                    component: PharmacyDescription
                                },
                                {
                                    path: 'waiting-price',
                                    name: 'PharmacyWaitingPrice',
                                    meta: { label: 'Платное ожидание' },
                                    component: PharmacyWaitingPrice,
                                },
                            ]
                        },
                    ]
                },
                /** TODO - remove */

                {
                    path: 'demands',
                    meta: { label: 'Спросы' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: '',
                            component: Demands
                        },
                        {
                            path: 'create',
                            meta: { label: 'Создать' },
                            name: 'DemandCreate',
                            component: DemandCreate
                        },
                        {
                            path: ':id',
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: '',
                                    name: 'Demand',
                                    component: Demand,
                                },
                                {
                                    path: 'edit',
                                    meta: { label: 'Редактирование' },
                                    name: 'DemandEdit',
                                    component: DemandEdit
                                },
                            ]
                        },
                    ]
                },
                {
                    path: 'customers',
                    meta: { label: 'Клиенты' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: '',
                            name: 'Customers',
                            component: Customers
                        },
                        {
                            path: 'create',
                            meta: { label: 'Создать' },
                            name: 'CustomerCreate',
                            component: CustomerCreate
                        },
                        {
                            path: ':id',
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: '',
                                    name: 'Customer',
                                    component: Customer
                                },
                                {
                                    path: 'edit',
                                    meta: { label: 'Редактирование' },
                                    name: 'CustomerEdit',
                                    component: CustomerEdit
                                },
                                {
                                    path: 'orders',
                                    meta: { label: 'Заказы' },
                                    name: 'CustomerOrders',
                                    component: CustomerOrders
                                },
                                {
                                    path: 'promocodes',
                                    meta: { label: 'Промокоды' },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: '',
                                            component: CustomerPromocodes
                                        },
                                        {
                                            path: 'customer-promocode-create',
                                            meta: { label: 'Создание промокода' },
                                            name: 'CustomerPromocodes',
                                            component: CustomerPromocodeCreate
                                        },
                                    ]
                                },
                            ]
                        },
                    ]
                },
                {
                    path: 'business-companies',
                    meta: { label: 'Бизнес-компании' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: '',
                            name: 'BusinessCompanies',
                            component: BusinessCompanies
                        },
                        {
                            path: 'create',
                            meta: { label: 'Создать' },
                            name: 'BusinessCompanyCreate',
                            component: BusinessCompanyCreate
                        },
                        {
                            path: ':id',
                            name: 'BusinessCompany',
                            component: BusinessCompany
                        }
                    ]
                },
                {
                    path: 'delivery-zones',
                    meta: { label: 'Зонирование' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: '',
                            component: DeliveryZones
                        },
                        {
                            path: 'params',
                            meta: { label: 'Параметры' },
                            name: 'DeliveryZonesParams',
                            component: DeliveryZonesParams
                        },
                    ],
                },
                {
                    path: 'partners',
                    meta: { label: 'Партнеры' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: '',
                            component: Partners
                        },
                        {
                            path: 'create',
                            meta: { label: 'Создать' },
                            name: 'PartnerCreate',
                            component: PartnerCreate
                        },
                        {
                            path: 'archive',
                            meta: { label: 'Архив' },
                            name: 'PartnersArchive',
                            component: PartnersArchive
                        },
                        {
                            path: ':id',
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: '',
                                    name: 'Partner',
                                    component: Partner,
                                },
                                {
                                    path: 'edit',
                                    meta: { label: 'Редактирование' },
                                    name: 'PartnerEdit',
                                    component: PartnerEdit
                                },
                                {
                                    path: 'orders',
                                    meta: { label: 'Заказы' },
                                    name: 'PartnerOrders',
                                    component: PartnerOrders
                                },
                                {
                                    path: 'discount-cards',
                                    meta: { label: 'Скидочные карты' },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: '',
                                            name: 'PartnerDiscountCards',
                                            component: PartnerDiscountCards,
                                        },
                                        {
                                            path: 'create',
                                            meta: { label: 'Создание' },
                                            name: 'DiscountCardCreate',
                                            component: DiscountCardCreate,
                                        },
                                        {
                                            path: ':discount_card_id',
                                            component: {
                                                render(c) { return c('router-view') }
                                            },
                                            children: [
                                                {
                                                    path: '',
                                                    name: 'DiscountCardView',
                                                    component: DiscountCardView
                                                },
                                                {
                                                    path: 'edit',
                                                    meta: { label: 'Редактирование' },
                                                    name: 'DiscountCardEdit',
                                                    component: DiscountCardEdit
                                                },
                                                {
                                                    path: 'clients',
                                                    meta: { label: 'Клиенты' },
                                                    name: 'DiscountCardClients',
                                                    component: DiscountCardClients
                                                },
                                                {
                                                    path: 'import',
                                                    meta: { label: 'Импорт' },
                                                    name: 'DiscountCardImport',
                                                    component: DiscountCardImport
                                                },
                                            ]
                                        },
                                    ]
                                },
                                {
                                    path: 'reports',
                                    meta: { label: 'Отчеты' },
                                    name: 'PartnerReports',
                                    component: PartnerReports
                                },
                                {
                                    path: 'restaurants',
                                    meta: { label: 'Рестораны' },
                                    name: 'PartnerRestaurants',
                                    component: PartnerRestaurants
                                },
                                {
                                    path: 'grocers',
                                    meta: { label: 'Магазины' },
                                    name: 'PartnerGrocers',
                                    component: PartnerGrocers
                                },
                                {
                                    path: 'pharmacy',
                                    meta: { label: 'Аптеки' },
                                    name: 'PartnerPharmacy',
                                    component: PartnerPharmacy
                                },
                                {
                                    path: 'assistants',
                                    meta: { label: 'Помощники' },
                                    name: 'PartnerAssistant',
                                    component: PartnerAssistant
                                },
                                {
                                    path: ':code',
                                    name: 'PartnerEntities',
                                    component: PartnerEntities
                                },
                            ]
                        },
                    ]
                },
                {
                    path: 'vip-partners',
                    meta: { label: 'Партнеры VipCity' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: '',
                            component: VipPartners
                        },
                        {
                            path: 'create',
                            meta: { label: 'Создать' },
                            name: 'VipPartnerCreate',
                            component: VipPartnerCreate
                        },
                        {
                            path: 'orders',
                            meta: { label: 'Заказы' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: '',
                                    name: 'VipPartnerOrdersAll',
                                    component: VipPartnerOrdersAll,
                                },
                                {
                                    path: 'unallocated',
                                    meta: { label: 'Нераспределенные' },
                                    name: 'VipPartnerOrdersUnallocated',
                                    component: VipPartnerOrdersUnallocated,
                                },
                                {
                                    path: ':order_id',
                                    // meta: { label: 'Заказ' },
                                    name: 'VipPartnerUnallocatedOrder',
                                    component: VipPartnerOrder,
                                },
                            ]
                        },
                        
                        {
                            path: ':id',
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: '',
                                    name: 'VipPartner',
                                    component: VipPartner,
                                },
                                {
                                    path: 'edit',
                                    meta: { label: 'Редактирование' },
                                    name: 'VipPartnerEdit',
                                    component: VipPartnerEdit
                                },
                                {
                                    path: 'orders',
                                    meta: { label: 'Заказы' },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: '',
                                            name: 'VipPartnerOrders',
                                            component: VipPartnerOrders,
                                        },
                                        {
                                            path: ':order_id',
                                            // meta: { label: 'Заказ' },
                                            name: 'VipPartnerOrder',
                                            component: VipPartnerOrder,
                                        },
                                    ]
                                },
                                {
                                    path: 'reports',
                                    meta: { label: 'Отчеты' },
                                    name: 'VipPartnerReports',
                                    component: VipPartnerReports
                                },
                            ]
                        },
                    ]
                },
                {
                    path: 'promocodes',
                    meta: { label: 'Промокоды' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: '',
                            meta: { label: 'Все промокоды' },
                            name: 'Promocodes',
                            component: Promocodes
                        },
                        {
                            path: 'mass-generation',
                            meta: { label: 'Массовая генерация' },
                            name: 'PromocodeMassGeneration',
                            component: PromocodeMassGeneration
                        },
                        {
                            path: 'mass-generations/:id',
                            meta: { label: 'Детали массовой генерации' },
                            name: 'MassGenerationDetail',
                            component: HistoryDetail
                        },
                        {
                            path: 'history/:id',
                            meta: { label: 'Детали генерации' },
                            name: 'HistoryDetail',
                            component: HistoryDetail
                        },
                        {
                            path: 'personal',
                            meta: { label: 'Персональная генерация' },
                            name: 'PromocodePersonalGeneration',
                            component: PromocodePersonalGeneration
                        },
                        {
                            path: 'history',
                            meta: { label: 'История генераций' },
                            name: 'PromocodeHistory',
                            component: PromocodeHistory
                        },
                        {
                            path: 'create',
                            meta: { label: 'Создать' },
                            name: 'PromocodeCreate',
                            component: PromocodeCreate
                        },
                        {
                            path: ':id',
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: '',
                                    name: 'Promocode',
                                    component: Promocode,
                                },
                                {
                                    path: 'edit',
                                    meta: { label: 'Редактирование' },
                                    name: 'PromocodeEdit',
                                    component: PromocodeEdit
                                },
                                {
                                    path: 'orders',
                                    meta: { label: 'Заказы' },
                                    name: 'PromocodeOrders',
                                    component: PromocodeOrders
                                },
                            ]
                        },
                    ]
                },
                {
                    path: 'promotions',
                    meta: { label: 'Акции' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: '',
                            component: CommonPromotions
                        },
                        {
                            path: 'create',
                            meta: { label: 'Создать' },
                            name: 'CreateCommonPromotion',
                            component: CreateCommonPromotion
                        },
                        {
                            path: ':id',
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: '',
                                    name: 'Promotion',
                                    component: CommonPromotion,
                                },
                                {
                                    path: 'edit',
                                    meta: { label: 'Редактирование' },
                                    name: 'EditCommonPromotion',
                                    component: EditCommonPromotion
                                },
                                {
                                    path: 'clients',
                                    meta: { label: 'Клиенты' },
                                    name: 'CommonPromotionClients',
                                    component: CommonPromotionClients
                                },
                                {
                                    path: 'import',
                                    meta: { label: 'Импорт' },
                                    name: 'CommonPromotionImport',
                                    component: CommonPromotionImport
                                },
                            ]
                        },
                    ]
                },
                {
                    path: 'couriers',
                    meta: { label: 'Курьеры' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: '',
                            component: Couriers
                        },
                        {
                            path: 'create',
                            meta: { label: 'Создать' },
                            name: 'CourierCreate',
                            component: CourierCreate
                        },
                        {
                            path: ':id',
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: '',
                                    name: 'Courier',
                                    component: Courier,
                                },
                                {
                                    path: 'edit',
                                    meta: { label: 'Редактирование' },
                                    name: 'CourierEdit',
                                    component: CourierEdit
                                },
                                {
                                    path: 'orders',
                                    meta: { label: 'Заказы' },
                                    name: 'CourierOrders',
                                    component: CourierOrders
                                },
                            ]
                        },
                    ]
                },
                {
                    path: 'concierges',
                    meta: { label: 'Консьержи' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: '',
                            component: Concierges
                        },
                        {
                            path: 'create',
                            meta: { label: 'Создать' },
                            name: 'ConciergeCreate',
                            component: ConciergeCreate
                        },
                        {
                            path: ':id',
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: '',
                                    name: 'Concierge',
                                    component: Concierge,
                                },
                                {
                                    path: 'edit',
                                    meta: { label: 'Редактирование' },
                                    name: 'ConciergeEdit',
                                    component: ConciergeEdit
                                },
                                {
                                    path: 'orders',
                                    meta: { label: 'Заказы' },
                                    name: 'ConciergeOrders',
                                    component: ConciergeOrders
                                },
                            ]
                        },
                    ]
                },
                {
                    path: 'banners',
                    meta: { label: 'Банеры' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: '',
                            component: Banners
                        },
                        {
                            path: 'create',
                            meta: { label: 'Создать' },
                            name: 'BannerCreate',
                            component: BannerCreate
                        },
                        {
                            path: ':id',
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: '',
                                    name: 'Banner',
                                    component: Banner,
                                },
                                {
                                    path: 'edit',
                                    meta: { label: 'Редактирование' },
                                    name: 'BannerEdit',
                                    component: BannerEdit
                                },
                            ]
                        },
                    ]
                },
                {
                    path: 'ads-campaigns',
                    meta: { label: 'Промо страницы' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: '',
                            component: AdsCampaigns
                        },
                        {
                            path: 'create',
                            meta: { label: 'Создать' },
                            name: 'AdsCampaignCreate',
                            component: AdsCampaignCreate
                        },
                        {
                            path: ':id',
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: '',
                                    name: 'AdsCampaign',
                                    component: AdsCampaign,
                                },
                                {
                                    path: 'edit',
                                    meta: { label: 'Редактирование' },
                                    name: 'AdsCampaignEdit',
                                    component: AdsCampaignEdit
                                },
                            ]
                        },
                    ]
                },
                {
                    path: 'ads-places',
                    meta: { label: 'Рекламные места' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: '',
                            component: AdsPlaces
                        },
                        {
                            path: 'create',
                            meta: { label: 'Создать' },
                            name: 'AdsPlaceCreate',
                            component: AdsPlaceCreate
                        },
                        {
                            path: ':id',
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: '',
                                    name: 'AdsPlace',
                                    component: AdsPlace,
                                },
                                {
                                    path: 'edit',
                                    meta: { label: 'Редактирование' },
                                    name: 'AdsPlaceEdit',
                                    component: AdsPlaceEdit
                                },
                            ]
                        },
                    ]
                },
                {
                    path: 'other-delivery',
                    meta: { label: 'Сторонние доставки' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: '',
                            component: OtherDeliveries
                        },
                        {
                            path: 'create',
                            meta: { label: 'Создать' },
                            name: 'OtherDeliveryCreate',
                            component: OtherDeliveryCreate
                        },
                        {
                            path: ':id',
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: '',
                                    name: 'OtherDelivery',
                                    component: OtherDelivery,
                                },
                                {
                                    path: 'edit',
                                    meta: { label: 'Редактирование' },
                                    name: 'OtherDeliveryEdit',
                                    component: OtherDeliveryEdit
                                },
                            ]
                        },
                    ]
                },
                {
                    path: '/onboarding',
                    meta: { label: 'Онбординг' },
                    component: {
                      render(c) {
                        return c('router-view');
                      },
                    },
                    children: [
                      {
                        path: '',
                        component: Onboarding,
                      },
                      {
                        path: 'create',
                        meta: { label: 'Создать' },
                        name: 'OnboardingCreate',
                        component: OnboardingCreate,
                      },
                      {
                        path: ':id',
                        component: {
                          render(c) {
                            return c('router-view');
                          },
                        },
                        children: [
                          {
                            path: '',
                            redirect: 'edit',
                          },
                          {
                            path: 'edit',
                            meta: { label: 'Редактирование' },
                            name: 'OnboardingEdit',
                            component: OnboardingEdit,
                          },
                          {
                            path: 'stories',
                            meta: { label: 'Сторисы' },
                            name: 'OnboardingStories',
                            component: OnboardingStories,
                          },
                        ],
                      },
                    ],
                  },
                  
  
                {
                    path: 'stories',
                    meta: { label: 'Сторис' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: '',
                            component: Stories
                        },
                        {
                            path: 'create',
                            meta: { label: 'Создать' },
                            name: 'StoryCreate',
                            component: StoryCreate
                        },
                        {
                            path: 'settings',
                            meta: { label: 'Настройки' },
                            name: 'StorySettings',
                            component: StorySettings
                        },
                        {
                            path: ':id',
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: '',
                                    name: 'Story',
                                    component: Story,
                                },
                                {
                                    path: 'edit',
                                    meta: { label: 'Редактирование' },
                                    name: 'StoryEdit',
                                    component: StoryEdit
                                },
                            ]
                        },
                    ]
                },
                {
                    path: 'profile',
                    meta: { label: 'Профиль' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: '',
                            redirect: 'view',
                        },
                        {
                            path: 'view',
                            meta: { label: 'Просмотр' },
                            name: 'Profile',
                            component: Profile
                        }
                    ]
                },
                {
                    path: 'settings',
                    meta: { label: 'Настройки' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: '',
                            redirect: 'main-page',
                        },
                        {
                            path: 'main-page',
                            name: 'MainPageSettings',
                            meta: { label: 'Настройки главной страницы' },
                            component: MainPageSettings
                        },
                        {
                            path: 'desktop-menu',
                            name: 'DesktopMenuSettings',
                            meta: { label: 'Настройки меню для десктопа' },
                            component: DesktopMenuSettings
                        },
                        {
                            path: 'payment-page',
                            name: 'PaymentPageSettings',
                            meta: { label: 'Настройки страницы оплаты' },
                            component: PaymentPageSettings
                        },
                        {
                            path: 'repeat-order-sheet',
                            name: 'RepeatOrderSheetSettings',
                            meta: { label: 'Настройки попапа повтора заказа' },
                            component: RepeatOrderSheetSettings
                        },
                        {
                            path: 'iiko-cards',
                            name: 'IikoCardsSettings',
                            meta: { label: 'iiko Cards' },
                            component: IikoCardsSettings
                        },
                        {
                            path: 'shop-catalog',
                            redirect: '/shop-catalog'
                        },
                        {
                            path: 'iiko-card-qr-schedule',
                            name: 'IikoCardQrScheduleSettings',
                            meta: { label: 'QR по расписанию (iiko)' },
                            component: IikoCardQrScheduleSettings
                        },
                        {
                            path: 'agreement',
                            name: 'AgreementSettings',
                            meta: { label: 'Текст пользовательского соглашения' },
                            component: AgreementSettings
                        },
                        {
                            path: 'personal-information',
                            name: 'RepeatOrderSheetSettings',
                            meta: { label: 'Текст политики обработки персональной информации' },
                            component: PersonalInformationSettings
                        },
                        {
                            path: 'verification',
                            name: 'VerificationSettings',
                            meta: { label: 'Исключения верификации' },
                            component: VerificationSettings
                        },
                        {
                            path: 'service-fee',
                            name: 'ServiceFeeSettings',
                            meta: { label: 'Сервисный сбор' },
                            component: ServiceFeeSettings
                        },
                        {
                            path: 'order-upsell',
                            name: 'OrderUpsellSettings',
                            meta: { label: 'Допродажи в статусе заказа' },
                            component: OrderUpsellSettings,
                        },
                        {
                            path: 'feedback',
                            name: 'FeedbackSettings',
                            meta: { label: 'Обратная связь' },
                            component: FeedbackSettings
                        },
                        {
                            path: 'version',
                            name: 'VersionSettings',
                            meta: { label: 'Версии' },
                            component: VersionSettings
                        },
                        {
                            path: 'faq',
                            name: 'FaqSettings',
                            meta: { label: 'Вопрос-ответ (FAQ)' },
                            component: FaqSettings
                        },
                        {
                            path: 'chat-quick-replies',
                            name: 'ChatQuickReplies',
                            meta: { label: 'Шаблоны сообщений в чатах' },
                            component: ChatQuickReplies
                        },
                        {
                            path: 'referal-program',
                            name: 'ReferalProgramSerttings',
                            meta: { label: 'Реферальная программа' },
                            component: ReferalProgramSerttings
                        },
                        {
                            path: 'discount-on-orders',
                            name: 'DiscountOnOrdersSerttings',
                            meta: { label: 'Скидка за n-заказов' },
                            component: DiscountOnOrdersSerttings
                        },
                        {
                            path: 'card-scan-gamification',
                            name: 'CardScanGamificationSettings',
                            meta: { label: 'Геймификация сканирования карт' },
                            component: CardScanGamificationSettings
                        },
                        {
                            path: 'delivery',
                            name: 'DeliverySettings',
                            meta: { label: 'Настройки доставки' },
                            component: DeliverySettings
                        },
                        {
                            path: 'entities',
                            meta: { label: 'Типы бизнеса' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: '',
                                    name: 'EntitiesSettings',
                                    meta: { label: 'Типы бизнеса' },
                                    component: EntitiesTypeSettings
                                },
                                {
                                    path: 'create',
                                    name: 'EntityTypeCreate',
                                    meta: { label: 'Создание сервиса' },
                                    component: EntityTypeCreate
                                },
                                {
                                    path: ':id',
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: '',
                                            name: 'EntityTypeSettings',
                                            meta: { label: 'Сервис' },
                                            component: EntityTypeSettings,
                                        },
                                        {
                                            path: 'telegram',
                                            name: 'EntityPartnerBot',
                                            meta: { label: 'Бот партнеров' },
                                            component: EntityPartnerBot,
                                        },
                                        {
                                            path: 'statuses',
                                            name: 'EntityStatuses',
                                            meta: { label: 'Статусы сервиса' },
                                            component: EntityStatuses,
                                        },
                                        {
                                            path: 'pushes',
                                            name: 'EntityPushes',
                                            meta: { label: 'Пуши сервиса' },
                                            component: EntityPushes,
                                        },
                                        {
                                            path: 'images',
                                            name: 'EntitiesImages',
                                            meta: { label: 'Изображения' },
                                            component: EntitiesImages,
                                        },
                                        {
                                            path: 'delivery',
                                            name: 'EntitiesDelivery',
                                            meta: { label: 'Доставка' },
                                            component: EntitiesDelivery,
                                        },
                                        {
                                            path: 'delivery-settings',
                                            name: 'EntitiesDeliverySettings',
                                            meta: { label: 'Доставка' },
                                            component: EntitiesDeliverySettings,
                                        },
                                        {
                                            path: 'waiting-price',
                                            name: 'EntitiesWaitingPrice',
                                            meta: { label: 'Платное ожидание' },
                                            component: EntitiesWaitingPrice,
                                        },
                                        {
                                            path: 'common',
                                            meta: { label: 'Тип бизнеса' },
                                            component: {
                                                render(c) { return c('router-view') }
                                            },
                                            children: [
                                                {
                                                    path: '',
                                                    name: 'EntityType',
                                                    component: EntityType
                                                },
                                                {
                                                    path: 'edit',
                                                    name: 'EntityTypeEdit',
                                                    meta: { label: 'Редактирование типа бизнеса' },
                                                    component: EntityTypeEdit
                                                },
                                            ]
                                        },
                                        {
                                            path: 'dialogs',
                                            meta: { label: 'Окна статусов' },
                                            component: {
                                                render(c) { return c('router-view') }
                                            },
                                            children: [
                                                {
                                                    path: '',
                                                    name: 'EntityStatusDialogStatuses',
                                                    meta: { label: 'Окна статусов' },
                                                    component: EntitiesStatusDialogStatuses,
                                                },
                                                {
                                                    path: 'settings',
                                                    meta: { label: 'Настройки' },
                                                    name: 'EntityStatusDialogsSettings',
                                                    component: EntitiesStatusDialogSettings
                                                },
                                                {
                                                    path: ':status',
                                                    name: 'EntityStatusDialogStatus',
                                                    meta: { label: 'Статус' },
                                                    component: EntitiesStatusDialogStatus
                                                },
                                            ]
                                        },
                                    ]
                                },
                            ]
                        },
                        {
                            path: 'restaurants',
                            meta: { label: 'Настройки ресторанов' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: '',
                                    name: 'RestaurantsSettings',
                                    meta: { label: 'Настройки ресторанов' },
                                    component: RestaurantsSettings,
                                },
                                {
                                    path: 'statuses',
                                    name: 'RestaurantsStatuses',
                                    meta: { label: 'Статусы в приложении' },
                                    component: RestaurantsStatuses,
                                },
                                {
                                    path: 'types',
                                    name: 'RestaurantTypes',
                                    meta: { label: 'Категории ресторанов' },
                                    component: RestaurantTypes,
                                },
                                {
                                    path: 'pushes',
                                    name: 'RestaurantsPushes',
                                    meta: { label: 'Клиентские пуши' },
                                    component: RestaurantsPushes,
                                },
                                {
                                    path: 'images',
                                    name: 'RestaurantsImages',
                                    meta: { label: 'Изображения' },
                                    component: RestaurantsImages,
                                },
                                {
                                    path: 'dish-images',
                                    name: 'RestaurantsDishImages',
                                    meta: { label: 'Изображения для товаров' },
                                    component: RestaurantsDishImages,
                                },
                                {
                                    path: 'telegram',
                                    name: 'RestaurantsPartnerBot',
                                    meta: { label: 'Бот партнеров' },
                                    component: RestaurantsPartnerBot,
                                },
                                {
                                    path: 'delivery',
                                    name: 'RestaurantsDelivery',
                                    meta: { label: 'Доставка' },
                                    component: RestaurantsDelivery,
                                },
                                {
                                    path: 'delivery-settings',
                                    name: 'RestaurantsDeliverySettings',
                                    meta: { label: 'Настройки доставки' },
                                    component: RestaurantsDeliverySettings,
                                },
                                {
                                    path: 'waiting-price',
                                    name: 'RestaurantsWaitingPrice',
                                    meta: { label: 'Платное ожидание' },
                                    component: RestaurantsWaitingPrice,
                                },
                                {
                                    path: 'dialogs',
                                    meta: { label: 'Окна статусов' },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: '',
                                            name: 'RestaurantsStatusDialogStatuses',
                                            meta: { label: 'Окна статусов' },
                                            component: StatusDialogStatuses,
                                        },
                                        {
                                            path: 'settings',
                                            meta: { label: 'Настройки' },
                                            name: 'RestaurantStatusDialogsSettings',
                                            component: StatusDialogSettings
                                        },
                                        {
                                            path: ':status',
                                            name: 'RestaurantsStatusDialogStatus',
                                            meta: { label: 'Статус' },
                                            component: StatusDialogStatus
                                        },
                                    ]
                                },
                            ]
                        },
                        {
                            path: 'grocers',
                            meta: { label: 'Настройки магазинов' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: '',
                                    name: 'GrocersSettings',
                                    meta: { label: 'Настройки магазинов' },
                                    component: GrocersSettings,
                                },
                                {
                                    path: 'statuses',
                                    name: 'GrocersStatuses',
                                    meta: { label: 'Статусы в приложении' },
                                    component: GrocersStatuses,
                                },
                                {
                                    path: 'pushes',
                                    name: 'GrocersPushes',
                                    meta: { label: 'Клиентские пуши' },
                                    component: GrocersPushes,
                                },
                                {
                                    path: 'telegram',
                                    name: 'GrocersPartnerBot',
                                    meta: { label: 'Бот партнеров' },
                                    component: GrocersPartnerBot,
                                },
                                {
                                    path: 'delivery',
                                    name: 'GrocersDelivery',
                                    meta: { label: 'Доставка' },
                                    component: GrocersDelivery,
                                },
                                {
                                    path: 'delivery-settings',
                                    name: 'GrocersDeliverySettings',
                                    meta: { label: 'Настройки доставки' },
                                    component: GrocersDeliverySettings,
                                },
                                {
                                    path: 'waiting-price',
                                    name: 'GrocersWaitingPrice',
                                    meta: { label: 'Платное ожидание' },
                                    component: GrocersWaitingPrice,
                                },
                                {
                                    path: 'images',
                                    name: 'GrocersImages',
                                    meta: { label: 'Изображения' },
                                    component: GrocersImages,
                                },
                                {
                                    path: 'dialogs',
                                    meta: { label: 'Окна статусов' },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: '',
                                            name: 'GrocersStatusDialogStatuses',
                                            meta: { label: 'Окна статусов' },
                                            component: StatusDialogStatuses,
                                        },
                                        {
                                            path: 'settings',
                                            meta: { label: 'Настройки' },
                                            name: 'GrocersStatusDialogsSettings',
                                            component: StatusDialogSettings
                                        },
                                        {
                                            path: ':status',
                                            name: 'GrocersStatusDialogStatus',
                                            meta: { label: 'Статус' },
                                            component: StatusDialogStatus
                                        },
                                    ]
                                },
                            ]
                        },
                        {
                            path: 'pharmacies',
                            meta: { label: 'Настройки аптек' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: '',
                                    name: 'PharmacySettings',
                                    meta: { label: 'Настройки аптек' },
                                    component: PharmacySettings,
                                },
                                {
                                    path: 'telegram',
                                    name: 'PharmaciesPartnerBot',
                                    meta: { label: 'Бот партнеров' },
                                    component: PharmaciesPartnerBot,
                                },
                                {
                                    path: 'delivery',
                                    name: 'PharmaciesDelivery',
                                    meta: { label: 'Доствка' },
                                    component: PharmaciesDelivery,
                                },
                                {
                                    path: 'waiting-price',
                                    name: 'PharmaciesWaitingPrice',
                                    meta: { label: 'Платное ожидание' },
                                    component: PharmaciesWaitingPrice,
                                },
                            ]
                        },
                    ]
                },
                {
                    path: 'administrators',
                    meta: { label: 'Администраторы' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: '',
                            name: 'Administrators',
                            component: Administrators
                        },
                        {
                            path: ':id',
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: '',
                                    name: 'Administrator',
                                    component: Administrator
                                },
                                {
                                    path: 'settings',
                                    meta: { label: 'Настройки' },
                                    name: 'AdministratorSettings',
                                    component: AdministratorSettings
                                }
                            ]
                        },
                    ]
                },
                {
                    path: '/export',
                    meta: { label: 'Файлы экспорта' },
                    name: 'ExportPage',
                    component: ExportPage,
                },
                {
                    path: '/push-status',
                    meta: { label: 'Статусы отправки push' },
                    name: 'PushStatusPage',
                    component: PushStatusPage,
                },
                {
                    path: '/content-health',
                    meta: { label: 'Контент партнёров' },
                    component: {
                        render (c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: '',
                            name: 'ContentHealth',
                            component: ContentHealth
                        },
                        {
                            path: ':type/:id',
                            meta: { label: 'Карточка' },
                            name: 'ContentHealthDetail',
                            component: ContentHealthDetail
                        }
                    ]
                },
                {
                    path: 'categories',
                    meta: { label: 'Категории' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: '',
                            meta: { label: 'Категории' },
                            name: 'Categories',
                            component: Categories
                        },
                        {
                            path: ':id',
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: '',
                                    name: 'Category',
                                    component: Category
                                }
                            ]
                        }
                    ]
                },
                {
                    path: 'addresses',
                    meta: { label: 'Адреса' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: '',
                            meta: { label: 'Категории' },
                            name: 'Addresses',
                            component: Addresses
                        },
                    ]
                },
                {
                    path: 'verification-codes',
                    meta: { label: 'Коды верификации' },
                    name: 'VerificationCodes',
                    component: VerificationCodes
                },
                {
                    path: 'sms-service',
                    meta: { label: 'СМС Сервис' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: '',
                            meta: { label: 'Логи' },
                            name: 'SMSServiceLogs',
                            component: SMSServiceLogs,
                        },
                        {
                            path: 'test',
                            meta: { label: 'Проверка' },
                            name: 'SMSServiceTest',
                            component: SMSServiceTest,
                        }
                    ]
                },
                {
                    path: 'telegram',
                    meta: { label: 'Telegram' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: '',
                            meta: { label: 'Telegram' },
                            name: 'Telegram',
                            component: Telegram,
                        },
                        {
                            path: 'service-bots',
                            meta: { label: 'Сервисные боты' },
                            name: 'ServiceBots',
                            component: ServiceBots,
                        },
                        {
                            path: 'chats',
                            meta: { label: 'Telegram' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: '',
                                    meta: { label: 'Тест' },
                                    name: 'TelegramTest',
                                    component: TelegramTest
                                },
                                {
                                    path: 'settings',
                                    meta: { label: 'Настройки чатов' },
                                    name: 'TelegramSettings',
                                    component: TelegramSettings
                                },
                            ]
                        },
                    ]
                },
                {
                    path: 'max',
                    meta: { label: 'MAX' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: '',
                            meta: { label: 'MAX' },
                            name: 'Max',
                            component: Max,
                        },
                        {
                            path: 'chats',
                            meta: { label: 'MAX' },
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: 'settings',
                                    meta: { label: 'Настройки чатов' },
                                    name: 'MaxSettings',
                                    component: MaxSettings,
                                },
                            ]
                        },
                    ]
                },
                {
                    path: 'courier-service',
                    meta: { label: 'Курьерский сервис' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: '',
                            meta: { label: 'Курьерский сервис' },
                            name: 'CourierService',
                            component: CourierService
                        },
                        {
                            path: 'start-towers',
                            meta: { label: 'Начало работы(башни)' },
                            name: 'StartTowers',
                            component: StartTowers
                        },
                        {
                            path: 'courier-queue',
                            meta: { label: 'Список курьеров' },
                            name: 'CourierList',
                            component: CourierList
                        },
                    ]
                },
                {
                    path: 'iiko-hooks',
                    meta: { label: 'Вебхуки iiko' },
                    name: 'IikoHooks',
                    component: IikoHooks
                },
                {
                    path: 'yuma-hooks',
                    meta: { label: 'Вебхуки Yuma' },
                    name: 'YumaHooks',
                    component: YumaHooks
                },
                {
                    path: 'change-logs',
                    meta: { label: 'Логи' },
                    name: 'ChangeLogs',
                    component: ChangeLogs
                },
                {
                    path: 'customer-logs',
                    meta: { label: 'Установки' },
                    name: 'CustomerLogs',
                    component: CustomerLogs
                },
                {
                    path: 'forms-results',
                    meta: { label: 'Результаты форм' },
                    name: 'FormResults',
                    component: FormResults
                },
                {
                    path: 'tower-time',
                    meta: { label: 'Башни' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: '',
                            meta: { label: 'Башни' },
                            name: 'Towers',
                            component: Towers
                        },
                        {
                            path: ':id',
                            meta: { label: 'Время подхода к башне' },
                            name: 'TowerTime',
                            component: TowerTime
                        },
                    ]
                },
                {
                    path: 'surveys',
                    meta: { label: 'Опросы' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: '',
                            component: Surveys
                        },
                        {
                            path: 'create',
                            meta: { label: 'Создать' },
                            name: 'SurveyCreate',
                            component: SurveyCreate
                        },
                        {
                            path: ':id',
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: '',
                                    name: 'Survey',
                                    component: Survey,
                                },
                                {
                                    path: 'edit',
                                    meta: { label: 'Редактирование' },
                                    name: 'SurveyEdit',
                                    component: SurveyEdit
                                },
                                {
                                    path: 'results',
                                    meta: { label: 'Результаты' },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: '',
                                            name: 'SurveyResults',
                                            component: SurveyResults
                                        },
                                        {
                                            path: ':customer_id',
                                            component: {
                                                render(c) { return c('router-view') }
                                            },
                                            children: [
                                                {
                                                    path: '',
                                                    name: 'SurveyResult',
                                                    component: SurveyResult
                                                }
                                            ]
                                        },
                                    ]
                                },
                                {
                                    path: 'questions',
                                    meta: { label: 'Вопросы' },
                                    component: {
                                        render(c) { return c('router-view') }
                                    },
                                    children: [
                                        {
                                            path: '',
                                            name: 'SurveyQuestions',
                                            component: SurveyQuestions,
                                        },
                                        {
                                            path: 'create',
                                            meta: { label: 'Создать' },
                                            name: 'SurveyQuestionCreate',
                                            component: SurveyQuestionCreate,
                                        },
                                        {
                                            path: ':question_id',
                                            component: {
                                                render(c) { return c('router-view') }
                                            },
                                            children: [
                                                {
                                                    path: '',
                                                    name: 'SurveyQuestion',
                                                    component: SurveyQuestion
                                                },
                                                {
                                                    path: 'edit',
                                                    meta: { label: 'Редактирование' },
                                                    name: 'SurveyQuestionEdit',
                                                    component: SurveyQuestionEdit
                                                },
                                            ]
                                        },
                                    ]
                                },
                            ]
                        },
                    ]
                },
                {
                    path: 'segments',
                    meta: { label: 'Сегменты' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: '',
                            name: 'Segments',
                            meta: { label: 'Сегменты' },
                            component: Segments
                        },
                        {
                            path: ':id',
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: '',
                                    name: 'Segment',
                                    component: Segment,
                                },
                                {
                                    path: 'edit',
                                    meta: { label: 'Редактирование' },
                                    name: 'SegmentEdit',
                                    component: SegmentEdit
                                },
                            ]
                        }
                    ]
                },
                {
                    path: 'trigger-campaigns',
                    meta: { label: 'Тригерные рассылки' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: '',
                            name: 'TriggerCampaigns',
                            meta: { label: 'Тригерные рассылки' },
                            component: TriggerCampaigns
                        },
                        {
                            path: 'create',
                            name: 'TriggerCampaignCreate',
                            meta: { label: 'Создание рассылки' },
                            component: TriggerCampaignCreate
                        },
                        {
                            path: ':id',
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: '',
                                    name: 'TriggerCampaign',
                                    component: TriggerCampaign,
                                },
                                {
                                    path: 'edit',
                                    meta: { label: 'Редактирование' },
                                    name: 'TriggerCampaignEdit',
                                    component: TriggerCampaignEdit
                                },
                            ]
                        }
                    ]
                },
                {
                    path: 'ab-tests',
                    meta: { label: 'АБ тестирование' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: '',
                            name: 'AbTests',
                            meta: { label: 'АБ тесты' },
                            component: AbTests
                        },
                        {
                            path: 'create',
                            meta: { label: 'Создать' },
                            name: 'AbTestCreate',
                            component: AbTestCreate
                        },
                        {
                            path: ':id',
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [
                                {
                                    path: '',
                                    name: 'AbTest',
                                    component: AbTest,
                                },
                                {
                                    path: 'edit',
                                    meta: { label: 'Редактирование' },
                                    name: 'AbTestEdit',
                                    component: AbTestEdit
                                },
                                {
                                    path: 'statistics',
                                    meta: { label: 'Статистика' },
                                    name: 'AbTestStatistics',
                                    component: AbTestStatistics
                                },
                            ]
                        }
                    ]
                },
                {
                    path: 'shop-catalog',
                    meta: { label: 'Стол заказов' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: '',
                            name: 'ShopCatalogSettings',
                            meta: { label: 'Каталог' },
                            component: ShopCatalogSettings
                        },
                        {
                            path: 'holidays',
                            name: 'ShopHolidaysSettings',
                            meta: { label: 'Выходные дни' },
                            component: ShopHolidaysSettings
                        },
                        {
                            path: 'feedback',
                            name: 'ShopFeedback',
                            meta: { label: 'Обращения' },
                            component: ShopFeedback
                        }
                    ]
                },
                {
                    path: 'iiko-orders',
                    meta: { label: 'iiko Заказы' },
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: '',
                            name: 'IikoOrders',
                            meta: { label: 'iiko Заказы' },
                            component: IikoOrders
                        },
                        {
                            path: ':partnerAlias/:orderId',
                            name: 'IikoOrder',
                            meta: { label: 'Заказ' },
                            component: IikoOrder
                        }
                    ]
                },
            ]
        },
        {
            path: '/pages',
            component: {
                render(c) { return c('router-view') }
            },
            children: [
                {
                    path: '',
                    redirect: 'login'
                },
                {
                    path: 'login',
                    name: 'Login',
                    component: Login
                },
                {
                    path: 'orders-fd-external',
                    name: 'OrdersFDExternal',
                    component: OrdersFDExternal
                }
            ]
        },
    ]
}
